import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { OrderDetailType } from '../../@types/order'
import {
  getGuestOrderRefundDetail,
  getOrderRefundDetail,
  postGuestReturn,
  postUserReturn,
} from '../../api/orderHistory'
import { getMall } from '../../api/product'
import { InputCheckbox } from '../../components/input/InputCheckbox'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import RefundNotice from '../../components/order/RefundNotice'
import RefundNoticeCenter from '../../components/order/RefundNoticeCenter'
import { OptionContentContent, OptionContentWrap, OptionWrap } from '../../components/product/ProductModal'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import '../../css/Order.css'
import { plusComma } from '../../js/script'
import { BtnGroupQuantity } from '../cart/CartList'

// 이미지 경로
const imgURL = '/images'

export default function OrderRefund() {
  const navigate = useNavigate()
  const location = useLocation()
  const { setIsLottie, hasAccessToken } = useCommonContext()

  const queryParams = new URLSearchParams(location.search)
  const orderNo = BigInt(queryParams.get('orderNo') || '0') || location?.state?.orderNo || 0
  const guestToken = Number(queryParams.get('guestToken')) || location?.state?.guestToken || null

  const [isCheckboxSameOrder, setIsCheckboxSameOrder] = useState<boolean>(false) // 주문자 동일 체크박스 상태
  const [orderItem, setOrderItem] = useState<OrderDetailType>()
  const [product, setProduct] = useState<any>([])
  const [claimReason, setClaimReason] = useState<any>('')
  const [claimDetailReason, setClaimDetailReason] = useState<any>('')
  const [productItem, setProductItem] = useState<any>([])
  const [refundNotice, setRefundNotice] = useState(false)
  const [cancelReason, setCancelReason] = useState<any>([])

  useEffect(() => {
    if (!hasAccessToken) {
      // @ts-ignore
      getGuestOrderRefundDetail(orderNo, guestToken)
        .then((res) => {
          setOrderItem(res.data)
          setIsLottie(false)
        })
        .catch((err) => console.log(err))
    } else {
      // @ts-ignore
      getOrderRefundDetail(orderNo)
        .then((res) => {
          setOrderItem(res.data)
          setIsLottie(false)
        })
        .catch((err) => console.log(err))
    }
  }, [])

  useEffect(() => {
    if (orderItem) {
      const newProductItems: any = [] // 새로운 제품 아이템을 저장할 배열

      orderItem.orderOptionsGroupByPartner?.forEach((el: any) => {
        el.orderOptionsGroupByDelivery[0]?.orderOptions.forEach((element: any) => {
          newProductItems.push(element) // 새로운 배열에 요소 추가
        })
      })

      setProductItem(newProductItems) // 한 번에 상태 업데이트
    }
  }, [orderItem])

  useEffect(() => {
    if (orderItem?.orderOptionsGroupByPartner) {
      if (
        product.length ===
        orderItem?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions?.length
      ) {
        setIsCheckboxSameOrder(true)
      } else {
        setIsCheckboxSameOrder(false)
      }
    }
  }, [product])
  useEffect(() => {
    if (productItem.length !== 0) {
      productItem?.map((el: any) => {
        const obj = {
          orderProductOptionNo: '',
          productCnt: 1,
        }
        obj.orderProductOptionNo = el.orderOptionNo
        obj.productCnt = el.orderCnt
        setProduct((prev: any) => [...prev, obj])
      })
    }
  }, [productItem])

  useEffect(() => {
    getMall().then((res) => {
      setCancelReason(res.data.claimReasonType)
    })
  }, [location])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>환불 신청</PageTitle>

            {/* 상품 정보 */}
            <OrderProductEdit>
              <div className='order_product_tit'>
                <div>
                  <p>상품 정보</p>
                  <em>주문번호 {orderItem?.orderNo}</em>
                </div>
                <span>
                  {`${orderItem?.paymentExpirationYmdt?.split(' ', 1)?.join('')?.replaceAll('-', '.')} 결제완료`}
                </span>
              </div>
              <div className='select_all'>
                <InputCheckbox
                  fontSize={isMobile ? 13 : 14}
                  text={'전체선택'}
                  isCheckbox={isCheckboxSameOrder}
                  setIsCheckbox={setIsCheckboxSameOrder}
                  event={() => {
                    if (!isCheckboxSameOrder) {
                      const array: any = []
                      orderItem?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map(
                        (el: any) => {
                          const obj = {
                            orderProductOptionNo: '',
                            productCnt: 1,
                          }
                          obj.orderProductOptionNo = el.orderOptionNo
                          obj.productCnt = el.orderCnt
                          array.push(obj)
                        }
                      )
                      setProduct(array)
                    } else {
                      setProduct([])
                    }
                  }}
                ></InputCheckbox>
              </div>
              {orderItem?.orderOptionsGroupByPartner
                ? orderItem?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions?.map(
                    (el: any, index: number) => {
                      if (el.claimStatusType === null) {
                        return (
                          <OrderRefundItem
                            key={index}
                            el={el}
                            setProduct={setProduct}
                            product={product}
                          ></OrderRefundItem>
                        )
                      } else {
                        return null
                      }
                    }
                  )
                : null}
            </OrderProductEdit>
            <OrderRefundApply>
              <div className='order_refund_title'>
                <strong>반품 신청</strong>
                <button
                  onClick={() => {
                    setRefundNotice((prev: boolean) => !prev)
                  }}
                >
                  취소/반품 안내
                </button>
              </div>

              <div>
                <dl>
                  <dt>반품 신청 사유</dt>
                  <dd
                    style={{
                      position: 'relative',
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                    }}
                  >
                    <select
                      name=''
                      id=''
                      onChange={(e) => {
                        setClaimReason(e.target.value)
                      }}
                    >
                      <option value=''>선택하세요</option>
                      {cancelReason?.map((el: any) => {
                        return (
                          <option key={el.value} value={el.value}>
                            {el.label}
                          </option>
                        )
                      })}
                    </select>
                    <img src='/images/icon_arrow_down.png' alt='dropdownarrow' />
                  </dd>
                </dl>
                <dl>
                  <dt>반품 상세 사유</dt>
                  <dd>
                    <textarea
                      name=''
                      id=''
                      placeholder='최소 10자 이상 작성해주세요.'
                      onChange={(e) => {
                        setClaimDetailReason(e.target.value)
                      }}
                    ></textarea>
                  </dd>
                </dl>
                <dl>
                  <dt>반품 수거 방법</dt>
                  <dd className='refund'>
                    <b>지정 택배 방문</b>
                    <span>판매사와 계약된 택배업체에서 방문수거</span>
                  </dd>
                </dl>
              </div>

              {product.length !== 0 && claimReason ? (
                <button
                  type='button'
                  className='refund_btn'
                  onClick={async () => {
                    if (product.length === 0) {
                      alert('환불하실 상품을 선택해주세요')
                      return
                    }
                    if (!claimReason) {
                      alert('환불 사유를 선택해주세요')
                      return
                    }
                    if (claimReason === 'OTHERS_BUYER' || (claimReason === 'OTHERS_SELLER' && !claimDetailReason)) {
                      alert('환불 상세 사유를 작성해주세요.')
                      return
                    }

                    try {
                      const address = orderItem?.shippingAddress
                      const receiverContact = address?.receiverContact1?.replaceAll('-', '') || ''

                      if (hasAccessToken) {
                        // 회원: product 배열 그대로 사용
                        await postUserReturn(
                          claimReason,
                          claimDetailReason,
                          address?.receiverName || '',
                          address?.receiverZipCd || '',
                          address?.receiverAddress || '',
                          address?.receiverJibunAddress || '',
                          address?.receiverDetailAddress || '',
                          receiverContact,
                          product
                        )
                        navigate(`/orderrefundcomplete`, {
                          state: { orderNo },
                        })
                      } else {
                        // 비회원: 환불/반품 처리되지 않은 상품만 추출
                        const array = productItem
                          .filter((el: any) => el.claimStatusType === null)
                          .map((el: any) => ({
                            orderProductOptionNo: el.orderOptionNo,
                            productCnt: el.orderCnt,
                          }))
                        await postGuestReturn(
                          claimReason,
                          claimDetailReason,
                          address?.receiverName || '',
                          address?.receiverZipCd || '',
                          address?.receiverAddress || '',
                          address?.receiverJibunAddress || '',
                          address?.receiverDetailAddress || '',
                          receiverContact,
                          array,
                          guestToken
                        )
                        navigate(`/orderrefundcomplete`, {
                          state: {
                            orderNo,
                            guestToken,
                          },
                        })
                      }
                    } catch (err) {
                      console.log(err)
                    }
                  }}
                >
                  환불 신청
                </button>
              ) : (
                <button type='button' className='refund_btn off'>
                  환불 신청
                </button>
              )}
            </OrderRefundApply>
          </div>
        </div>
      </div>
      {/* 취소/반품 안내 */}
      {refundNotice ? (
        isMobile ? (
          <RefundNotice isModal={refundNotice} setIsModal={setRefundNotice}></RefundNotice>
        ) : (
          <RefundNoticeCenter isModal={refundNotice} setIsModal={setRefundNotice}></RefundNoticeCenter>
        )
      ) : null}
    </>
  )
}

export function OrderRefundItem({ el, setProduct, product, lastNumber }: any) {
  const [isCheckboxSameOrder, setIsCheckboxSameOrder] = useState<boolean>(false) // 주문자 동일 체크박스 상태
  const [count, setCount] = useState<number>(1)

  useEffect(() => {
    setCount(el.orderCnt)
  }, [el])

  useEffect(() => {
    const userOption = product.find((elment: any) => elment.orderProductOptionNo === el.orderOptionNo)
    if (userOption) {
      setIsCheckboxSameOrder(true)
      return
    } else {
      setIsCheckboxSameOrder(false)
    }
  }, [product])

  return (
    <div className='order_item_edit'>
      <div
        style={{
          display: 'flex',
          gap: '12px',
          marginBottom: isMobile ? '24px' : '32px',
          paddingBottom: isMobile ? '24px' : '32px',
          borderBottom: '1px solid var(--colGray3)',
        }}
      >
        <div className='chk_box'>
          <InputCheckbox
            text={''}
            noGap={true}
            isCheckbox={isCheckboxSameOrder}
            setIsCheckbox={setIsCheckboxSameOrder}
            event={() => {
              const obj = { orderProductOptionNo: '', productCnt: 1 }
              if (!isCheckboxSameOrder) {
                if (product.length === 0) {
                  obj.orderProductOptionNo = el.orderOptionNo
                  obj.productCnt = count
                  setProduct([obj])
                } else {
                  product.map((element: any) => {
                    const array: any = [...product]
                    if (element.orderProductOpitionNo === el.orderOptionNo) {
                    } else {
                      obj.orderProductOptionNo = el.orderOptionNo
                      obj.productCnt = count
                      array.push(obj)
                    }
                    setProduct(array)
                  })
                }
              } else {
                let array: any = []
                product.map((element: any) => {
                  if (Number(element.orderProductOptionNo) === Number(el.orderOptionNo)) {
                    if (Number(product.length) === 1) {
                      array = []
                      setProduct(array)
                    }
                  } else {
                    array.push(element)
                  }
                  setProduct(array)
                })
              }
            }}
          ></InputCheckbox>
        </div>
        <div
          style={{
            display: 'flex',
            gap: isMobile ? 20 : 16,
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              gap: 20,
              marginBottom: isMobile ? '16px' : '0px',
            }}
          >
            <div
              className='img_box'
              style={{
                position: 'relative',
                maxWidth: isMobile ? 80 : 100,
                maxHeight: isMobile ? 80 : 100,
                borderRadius: 10,
                overflow: 'hidden',
              }}
            >
              <div
                className='dim'
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--colDimBlack)',
                  opacity: 0.03,
                  borderRadius: 10,
                  zIndex: 1,
                  display: isCheckboxSameOrder ? 'none' : 'block',
                }}
              ></div>
              <img
                src={el.imageUrl}
                alt='productImage'
                style={{
                  width: '100%',
                  height: '100%',
                }}
              />
            </div>
            <div style={{ width: 'auto' }}>
              <p
                style={{
                  color: 'var(--colBlack)',
                  fontSize: isMobile ? 12 : 14,
                  fontWeight: 700,
                  lineHeight: isMobile ? '14px' : '20px',
                }}
              >
                {el?.brandName}
              </p>
              <p
                style={{
                  color: 'var(--colBlack)',
                  textOverflow: 'ellipsis',
                  fontSize: isMobile ? 14 : 16,
                  fontWeight: 500,
                  lineHeight: isMobile ? '18px' : '20px',
                  marginTop: 4,
                }}
              >
                {el?.productName}
              </p>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-end',
                }}
              >
                <div>
                  <p
                    style={{
                      marginTop: 10,
                      color: 'var(--colGray6)',
                      fontSize: isMobile ? 12 : 14,
                      fontWeight: 500,
                      lineHeight: '16px',
                      textDecoration: 'line-through',
                    }}
                  >
                    {plusComma(el?.price?.standardAmt)}원
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 2,
                    }}
                  >
                    <div style={{ display: 'flex', gap: 6 }}>
                      <p
                        style={{
                          color: 'var(--colPointOrange)',
                          fontSize: isMobile ? 15 : 18,
                          fontWeight: 600,
                          lineHeight: isMobile ? '18px' : '22px',
                        }}
                      >
                        {Math.floor(
                          (el.price?.immediateDiscountAmt / (el?.price?.salePrice + el?.price?.addPrice)) * 100
                        )}
                        %
                      </p>
                      <p
                        style={{
                          color: 'var(--colBlack)',
                          fontSize: isMobile ? 15 : 18,
                          fontWeight: 600,
                          lineHeight: isMobile ? '18px' : '22px',
                        }}
                      >
                        {plusComma(el?.price?.salePrice + el?.price?.addPrice - el.price.immediateDiscountAmt)}원
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <OptionWrap
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '20px',
              }}
            >
              <OptionContentWrap style={{}}>
                <OptionContentContent
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: '2',
                    WebkitBoxOrient: 'vertical',
                  }}
                >
                  옵션 : {el?.optionTitle.split(': ')[1] ? el?.optionTitle.split(': ')[1] : el?.optionTitle}
                </OptionContentContent>
              </OptionContentWrap>
              <BtnGroupQuantity>
                <button>
                  <img
                    src={`${imgURL}/icon_minus2.svg`}
                    alt='감소'
                    onClick={() => {
                      if (count - 1 > 0) {
                        setCount((prev: number) => prev - 1)
                      } else {
                        alert('0보다 작을 수는 없습니다.')
                      }
                    }}
                  />
                </button>
                <input type='text' value={count} disabled={true} readOnly />
                <button>
                  <img
                    src={`${imgURL}/icon_plus2.svg`}
                    alt='증가'
                    onClick={() => {
                      if (el.orderCnt > count) {
                        setCount((prev: number) => prev + 1)
                      } else {
                        alert('주문수량보다 크게 환불할 수 없습니다.')
                      }
                    }}
                  />
                </button>
              </BtnGroupQuantity>
            </OptionWrap>
          </div>
        </div>
      </div>
    </div>
  )
}

export const OrderRefundApply = styled.p`
  padding: 24px 20px 48px;
  border-top: 8px solid var(--colGray1);
  & .order_refund_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--colGray3);
    padding-bottom: 16px;
    & strong {
      display: block;
      font-size: 16px;
      line-height: 24px;
      color: var(--colBlack);
    }
    button {
      padding: 8px 10px;
      background: none;
      border: 1px solid var(--colGray3);
      border-radius: 37.5px;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: var(--colGray7);
    }
  }

  & div {
    & dl {
      padding: 16px 0;
      border-bottom: 1px solid var(--colGray3);
      display: flex;
      align-items: center;
      gap: 16px;
      & dt {
        min-width: 85px;
        font-size: 13px;
        line-height: 20px;
        color: var(--colGray6);
        white-space: nowrap;
      }
      & dd {
        width: 100%;
        & select {
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgb(25, 25, 25);
          padding: 10px 0px 10px 14px;
          width: 100%;
          border-radius: 5px;
          border: 1px solid rgb(234, 234, 234);
          background-color: rgb(255, 255, 255);
          box-sizing: border-box;
          appearance: none;
        }
        & img {
          width: 16px;
          height: 16px;
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          background-color: white;
          pointer-events: none;
        }
        & textarea {
          font-family: 'Pretendard', sans-serif;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgb(25, 25, 25);
          padding: 10px 14px;
          width: 100%;
          border-radius: 5px;
          border: 1px solid rgb(234, 234, 234);
          background-color: rgb(255, 255, 255);
          box-sizing: border-box;
          appearance: none;
        }
        & b {
          display: block;
          color: var(--colBlack);
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
        }
        & span {
          margin-top: 4px;
          display: block;
          color: var(--colGray6);
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
  }
  & .refund_btn {
    display: block;
    width: 100%;
    margin-top: 20px;
    padding: 12px 16px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: var(--colWhite);
    background: var(--colBlack);
    border: 0;
    border-radius: 5px;
  }
  & .refund_btn.off {
    display: block;
    width: 100%;
    margin-top: 20px;
    padding: 12px 16px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: var(--colGray4);
    background: var(--colGray2);
    border: 0;
    border-radius: 5px;
  }
  @media screen and (min-width: 768px) {
    padding: 0 0 48px 0;
    border-top: none;
    & .order_refund_title {
      button {
        font-size: 14px;
        padding: 10px 12px;
      }
    }
    & strong {
      display: block;
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
      color: var(--colBlack);
    }
    & div {
      & dl {
        padding: 20px 0;
        border-bottom: 1px solid var(--colGray3);
        display: flex;
        align-items: center;
        gap: 16px;
        & dt {
          min-width: 120px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: var(--colGray6);
        }
        & dd {
          width: 100%;
          & select {
            font-size: 15px;
            font-weight: 500;
            line-height: 20px;
            color: rgb(25, 25, 25);
            padding: 10px 38px 10px 16px;
            width: 100%;
            border-radius: 5px;
            border: 1px solid rgb(234, 234, 234);
            background-color: rgb(255, 255, 255);
            box-sizing: border-box;
            appearance: none;
          }
          & img {
            width: 16px;
            height: 16px;
            position: absolute;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            background-color: white;
            pointer-events: none;
          }
          & textarea {
            font-family: 'Pretendard', sans-serif;
            font-size: 15px;
            font-weight: 500;
            line-height: 20px;
            color: rgb(25, 25, 25);
            padding: 14px 16px;
            width: 100%;
            border-radius: 5px;
            border: 1px solid rgb(234, 234, 234);
            background-color: rgb(255, 255, 255);
            box-sizing: border-box;
            appearance: none;
          }
          & b {
            display: block;
            color: var(--colBlack);
            font-size: 15px;
            font-weight: 500;
            line-height: 20px;
          }
          & span {
            margin-top: 4px;
            display: block;
            color: var(--colGray6);
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
          }
        }
        & dd.refund {
          padding: 20px 0;
        }
      }
    }
    & .refund_btn {
      display: block;
      width: 100%;
      margin-top: 20px;
      padding: 12px 16px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      color: var(--colWhite);
      background: var(--colBlack);
      border: 0;
      border-radius: 5px;
    }
  }
`
export const OrderInfoCont = styled.div`
  overflow-y: auto;
`
export const OrderProductEdit = styled.p`
  padding: 24px 20px;
  border-top: 8px solid var(--colGray1);
  & .select_all {
    padding-bottom: 24px;
    margin-bottom: 24px;
    border-bottom: 1px solid var(--colGray3);
  }
  & .order_product_tit {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-bottom: 14px;
    border-bottom: 1px solid var(--colGray3);
    margin-bottom: 20px;
    & div {
      & p {
        font-size: 16px;
        line-height: 24px;
        color: var(--colBlack);
        font-weight: 700;
      }
      & em {
        font-size: 14px;
        line-height: 18px;
        font-style: normal;
        margin-top: 4px;
        display: block;
      }
    }
    & span {
      font-size: 12px;
      line-height: 18px;
      color: var(--colGray6);
    }
  }
  @media screen and (min-width: 768px) {
    padding: 48px 0 0 0px;
    border-top: none;

    & .order_product_tit {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding-bottom: 20px;
      border-bottom: 1px solid var(--colGray3);
      margin-bottom: 24px;
      & div {
        & p {
          font-size: 18px;
          font-weight: 700;
          line-height: 24px;
          color: var(--colBlack);
        }
        & em {
          font-size: 15px;
          font-weight: 500;
          line-height: 20px;
          margin-top: 4px;
        }
      }
      & span {
        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        color: var(--colGray6);
      }
    }
  }
`
